import { createThemeContract } from '@vanilla-extract/css';
import { black, gray, purple } from '../palette';

export const baseThemeTokens = {
  // @deprecated use semantic/component vars instead
  color: {
    bgFill: {
      interactive: {
        primary: {
          active: purple[700],
        },
        secondary: {
          default: gray[300],
          active: gray[500],
          disabled: black[50],
        },
        tertiary: {
          default: 'transparent',
        },
      },
    },
  },
};
export const baseThemeVars = createThemeContract(baseThemeTokens);
